import { Outlet, ScrollRestoration } from "react-router-dom";
import Header from "./components/layout/Header.jsx";
import Footer from "./components/layout/Footer.jsx";
import BotonWhatsApp from "./components/ui/BotonWhatsApp.jsx";

export default function App() {
  return (
    <>
      <a className="skip-link" href="#contenido">
        Ir al contenido
      </a>
      <Header />
      <main id="contenido">
        <Outlet />
      </main>
      <Footer />
      <BotonWhatsApp />
      <ScrollRestoration />
    </>
  );
}
